<template>
	<div
		v-if="modules"
		id="module-builder"
		class="modules content-padding module-builder"
		:class="'pt-' + currentPostType"
	>
		<component
			v-for="(module, i) in modules"
			:is="currentModule(module).component"
			:data="currentModule(module).data"
			:key="i"
			:class="'pt-' + currentPostType + ' module module-' + currentModule(module).data.acf_fc_layout"
		/>
	</div>
</template>

<script>
import Modules from '@/components/modules/'

import { mapGetters } from 'vuex'

export default {
	name: 'module-builder',
	computed: {
		...mapGetters(['currentPage', 'currentPostType']),
		modules() {
			return this.currentPage && this.currentPage.acf && this.currentPage.acf.modules
				? this.currentPage.acf.modules
				: false
		},
	},
	methods: {
		currentModule(acfModule) {
			const moduleName = acfModule.acf_fc_layout
			const component =
				typeof Modules[moduleName] !== 'undefined' && Modules[moduleName]
					? Modules[moduleName]
					: Modules['nomodule']
			return { component, data: acfModule }
		},
	},
}
</script>
